(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cevimi-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', (event) => {
    const item = event.target.closest('.cv-faq__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cevimi-footer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const select = event.target.closest('.cv-footer__localization select[name="country_code"]');
    if (select && select.form) select.form.requestSubmit();
  });
  const enableCevimiLocalization = (scope) => {
    scope.querySelectorAll('.cv-footer__localization button[type="submit"]').forEach((button) => { button.hidden = true; });
  };
  enableCevimiLocalization(document);
  document.addEventListener('shopify:section:load', (event) => enableCevimiLocalization(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
